// extracted by mini-css-extract-plugin
export default {"three":"SecThree_three__axIBn","upText":"SecThree_upText__Jqw2W","image":"SecThree_image__dfHYv","downText":"SecThree_downText__DgV-E","downTextMain":"SecThree_downTextMain__A5dTu"};